import createAction from 'Store/utils/createAction';
const CLOSE_TOAST = 'CLOSE_TOAST';
const OPEN_TOAST = 'OPEN_TOAST';

function openToast(toastLabel: string, className: string | null | undefined, style?: CSSRuleList) {
  return createAction(OPEN_TOAST, {
    className,
    toastLabel,
    style,
  });
}

function closeToast() {
  return createAction(CLOSE_TOAST);
}

const showTemporaryToast =
  ({
    className,
    style,
    timeout = 2000,
    toastLabel,
  }: {
    className?: string;
    style?: CSSRuleList;
    timeout?: number;
    toastLabel: string;
  }) =>
  (dispatch: ReduxDispatch) => {
    return Promise.resolve(dispatch(openToast(toastLabel, className, style))).then(() => {
      setTimeout(() => dispatch(closeToast()), timeout);
    });
  };

export { CLOSE_TOAST, OPEN_TOAST, closeToast, openToast, showTemporaryToast };
